import React from 'react'
import { styled } from 'styled-components'


const HeroSection = ({title,tagline}) => {
  return (
    <Container>
        <div className='hero-info'>
        <h5>{title}</h5>
        {tagline &&   <p>{tagline}</p>}
        </div>
    </Container>
  )
}

const Container = styled.div`
    background-color: var(--color-black);
    color: var(--color-white);
    text-align: center;
    padding: 2em 0;
    .hero-info{
        line-height: 0.9;
        padding: 0 1em;
    }
    h5{
        font-weight: 400;
        font-size: 2em;
    }
    p{
        font-size: 1.2em;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: -2em;
    }

    /* Media Queries */
    @media only screen and (min-width: 800px){
        text-align: unset;
        padding: 3em 5em; 
        .hero-info{
            h5{
                font-weight: 600;
                font-size: 3em;
                &:last-child{
                    font-size: 2.6em;
                }
            }
        }
    }

    @media only screen and (min-width: 1200px){
        padding: 3em 10em;
    }
`;

export default HeroSection
